import { Constants } from '../_constants/shared.constants';
export const  successContainerTrip=(data)=> {
     return{ type: Constants.containerTripData.CONTAINER_DATA_SUCCESS,data }
     }
